/** =========================================================
 * Module: config.js
 * App routes and resources configuration
 =========================================================*/


(function () {
  'use strict';

  angular
    .module('app.routes')
    .config(routesConfig);

  routesConfig.$inject = ['$stateProvider', '$locationProvider', '$urlRouterProvider', 'RouteHelpersProvider'];

  function routesConfig($stateProvider, $locationProvider, $urlRouterProvider, helper) {
    // Set the following to true to enable the HTML5 Mode
    // You may have to set <base> tag in index and a routing configuration in your server
    $locationProvider.html5Mode(false);

    // defaults to dashboard
    $urlRouterProvider.otherwise('/app/order-tasks');

    //
    // Application Routes
    // -----------------------------------
    $stateProvider
      .state('login', {
        url: '/login',
        title: 'Login',
        resolve: helper.resolveFor('icons'),
        templateUrl: helper.basepath('pages/login.html')
      })
      .state('app', {
        url: '/app',
        abstract: true,
        templateUrl: helper.basepath('app.html'),
        resolve: helper.resolveFor('icons', 'ngDialog', 'date-time-picker', 'fancybox', 'localytics.directives', 'trix', 'infinite-scroll')
      })
      .state('app.page-order-tasks', {
        url: '/order-tasks',
        title: 'Order tasks',
        subTitle: 'List of order tasks',
        controller: 'OrderTasksController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-order-task-types', {
        url: '/order-task-types',
        title: 'Order task types',
        subTitle: 'List of order task types',
        controller: 'OrderTaskTypesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-orders', {
        url: '/orders',
        title: 'Orders',
        subTitle: 'List of orders',
        controller: 'OrdersController as c',
        templateUrl: helper.basepath('pages/orders.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-customers', {
        url: '/customers',
        title: 'Customers',
        subTitle: 'List of customers',
        controller: 'CustomersController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-maintenances', {
        url: '/maintenances',
        title: 'Maintenances',
        subTitle: 'List of maintenances',
        controller: 'MaintenancesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-maintenance-events', {
        url: '/maintenance-events',
        title: 'Maintenance events',
        subTitle: 'List of maintenance events',
        controller: 'MaintenanceEventsController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-workgroups', {
        url: '/workgroups',
        title: 'Workgroups',
        subTitle: 'List of workgroups',
        controller: 'WorkgroupsController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-users', {
        url: '/users',
        title: 'Users',
        subTitle: 'List of users',
        controller: 'UsersController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-roles', {
        url: '/roles',
        title: 'Roles',
        subTitle: 'List of roles',
        controller: 'RolesController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-emails', {
        url: '/emails',
        title: 'Emails',
        subTitle: 'Emails sent',
        controller: 'EmailsController as c',
        templateUrl: helper.basepath('pages/table.html'),
        params: {
          filters: []
        }
      })
      .state('app.page-system', {
        url: '/system',
        title: 'System',
        controller: 'SystemController as c',
        templateUrl: helper.basepath('pages/system.html')
      })

    //
    // CUSTOM RESOLVES
    //   Add your own resolves properties
    //   following this object extend
    //   method
    // -----------------------------------
    // .state('app.someroute', {
    //   url: '/some_url',
    //   templateUrl: 'path_to_template.html',
    //   controller: 'someController',
    //   resolve: angular.extend(
    //     helper.resolveFor(), {
    //     // YOUR RESOLVES GO HERE
    //     }
    //   )
    // })
    ;
  } // routesConfig
})();
